import { render, staticRenderFns } from "./MoleculeFeedSectionContentCardDesign3.vue?vue&type=template&id=0147986a&"
import script from "./MoleculeFeedSectionContentCardDesign3.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedSectionContentCardDesign3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports